import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { url: String }
  static targets = ["arrowLink", "auctionCell"]

  connect() {
    // Store bound methods to ensure they can be correctly removed in disconnect
    this.boundHighlight = this.highlightRow.bind(this)
    this.boundUnhighlight = this.unhighlightRow.bind(this)

    if (this.hasArrowLinkTarget) {
      this.arrowLinkTarget.addEventListener('mouseenter', this.boundHighlight)
      this.arrowLinkTarget.addEventListener('mouseleave', this.boundUnhighlight)
    }

    this.auctionCellTargets.forEach(cell => {
      cell.addEventListener('mouseenter', this.boundHighlight)
      cell.addEventListener('mouseleave', this.boundUnhighlight)
    })
  }

  disconnect() {
    if (this.hasArrowLinkTarget) {
      // Use the stored bound functions to remove the correct listeners
      this.arrowLinkTarget.removeEventListener('mouseenter', this.boundHighlight)
      this.arrowLinkTarget.removeEventListener('mouseleave', this.boundUnhighlight)
    }

    this.auctionCellTargets.forEach(cell => {
      cell.removeEventListener('mouseenter', this.boundHighlight)
      cell.removeEventListener('mouseleave', this.boundUnhighlight)
    })
  }

  highlightRow() {
    this.element.classList.add('arrow-hover')
  }

  unhighlightRow() {
    this.element.classList.remove('arrow-hover')
  }

  handleClick(event) {
    // Don't navigate if clicking on interactive elements
    const clickedElement = event.target
    const interactiveElements = [
      'A',           // Links
      'BUTTON',      // Buttons
      'INPUT',       // Input fields
      'SELECT',      // Select dropdowns
      'TEXTAREA'     // Text areas
    ]

    // Check if clicked element or its parent is an interactive element
    let element = clickedElement
    while (element && element !== this.element) {
      if (interactiveElements.includes(element.tagName)) {
        return // Don't navigate, let the original element handle the click
      }
      
      // Special check for elements with specific data-action attributes (like toggle)
      if (element.hasAttribute('data-action') && 
          element.getAttribute('data-action').includes('toggleProspects')) {
        return // Don't navigate for toggle buttons
      }
      
      element = element.parentElement
    }

    if (this.hasArrowLinkTarget) {
      // Do whatever clicking on arrow link would do
      this.arrowLinkTarget.click()
    } else if (this.urlValue) {
      // Fallback if arrow link does not exist
      visit(this.urlValue, { frame: "_top" })
    }
  }
}